import { endPoint } from './base.config';
import { account } from './account.api';
import { bank } from './bank.api';
import { bankTemplate } from './bankTemplate.api';
import { companyBank, companyBankV2 } from './companyBank.api';
import { companyBankService } from './companyBankService.api';
import { service } from './service.api';
import {
  companyUsers,
  companyUsersAlertVoucher,
  companyUsersReminder,
  companyUsersAssignPayment,
} from './companyUsers.api';
import { ehf } from './ehf.api';
import { globalRule } from './globalRule.api';
import { inbox } from './inbox.api';
import { localRule } from './localRule.api';
import { oryton } from './oryton.api';
import { queue } from './queue.api';
import { task, taskLabel, taskTemplate } from './task.api';
import { bankTransactionV2, transaction } from './transaction.api';
import { transactionImport } from './transactionImport.api';
import { transactionVoucher } from './transactionVoucher.api';
import { voucher, voucherAi, voucherV2 } from './voucher.api';
import { voucherPayments, voucherPaymentsV2 } from './voucherPayments.api';
import { voucherPaymentsAuth } from './voucherPaymentsAuth.api';
import { voucherPaymentsBasket } from './voucherPaymentsBasket.api';
import { voucherSuggestion } from './voucherSuggestion.api';
import { company } from './company.api';
import { companyService } from './companyService.api';
import { companyPaymentPackages } from './companyPaymentPackages.api';
import { users } from './users.api';
import { paymentPackages } from './paymentPackages.api';
import { bankCheckList } from './trackingBank.api';
import { internalTransfer } from './internalTransfer.api';
import { voucherLabel } from './voucherLabel.api';
import { transactionInfo } from './transactionInfo.api';
import { statistic, statisticV2 } from './statistic.api';
import { ztl, ztlV2 } from './ztl.api';
import { bilagskyTeam } from './bilagskyTeam.api';
import { logging } from './logging.api';
import { bankServices } from './bankServices.api';
import { dnb } from './dnb.api';
import { hsb } from './hsb.api';
import { sp1 } from './sp1.api';
import { fikenApi } from './fiken.api';
import { integration } from './integration.api';
import { supplierProductLine } from './supplierProductLine.api';
import { tripletexRequestLog } from './tripletexRequestLog.api';
import { tripletexVoucherPurchase } from './tripletexVoucherPurchase.api';
import { tripletexCompanyContact } from './tripletexCompanyContact.api';
import { mailBilagsky } from './mailBilagsky.api';
import { invoice } from './invoice.api';

const api = {
  authenticate: endPoint + 'auth',
  file: endPoint + 'file?file=',
  download: endPoint + 'file/download?file=',
  account,
  task,
  taskLabel,
  taskTemplate,
  voucher,
  voucherAi,
  voucherPayments,
  voucherPaymentsAuth,
  voucherPaymentsBasket,
  voucherSuggestion,
  transaction,
  transactionImport,
  transactionVoucher,
  bank,
  bankTemplate,
  companyBank,
  companyBankService,
  service,
  inbox,
  oryton,
  ehf,
  queue,
  globalRule,
  localRule,
  companyUsers,
  companyUsersReminder,
  companyUsersAlertVoucher,
  company,
  companyService,
  companyPaymentPackages,
  users,
  companyUsersAssignPayment,
  paymentPackages,
  bankCheckList,
  internalTransfer,
  voucherLabel,
  transactionInfo,
  statistic,
  ztl,
  bankServices,
  bilagskyTeam,
  logging,
  // v2
  bankTransactionV2,
  statisticV2,
  voucherPaymentsV2,
  voucherV2,
  companyBankV2,
  ztlV2,
  // bankservice server
  dnb,
  sp1,
  hsb,
  // fiken
  fikenApi,
  // Integration
  integration,
  supplierProductLine,
  // tripletex
  tripletexRequestLog,
  tripletexVoucherPurchase,
  tripletexCompanyContact,
  // mail bilagsky
  mailBilagsky,
  // Invoice
  invoice,
};

export default api;
